<template>
	<!-- 我的收益 -->
	<div class="qjylBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">我的收益</p>
				</div>
			</div>
		</van-sticky>
		<div class="qjylBoxNum">
			<div class="qjylNum_data">
				<div class="shouyi">
					<p><span>今日收益</span><i>￥{{userIncomelogList.today}}</i></p>
					<p><span>本月收益</span><i>￥{{userIncomelogList.this_month}}</i></p>
				</div>
				<div class="dataIcon" @click="showDataFn">
					<img src="../../assets/img/data.png" alt="">
				</div>
			</div>
			<div class="qjylNum" v-for="(item,idx) in userIncomelogList.log" :key="idx" v-if="userIncomelogList.log != []">
				<span>{{item.books_name}}</span>
				<span>￥{{item.money}}</span>
			</div>
			<div v-if="userIncomelogList.log == [] || userIncomelogList.log.length == 0 " style="text-align: center;margin-top: 30%;">
				<img src="../../assets/img/data_null.png" alt="" width="80px">
			</div>
		</div>
		<!-- 修改后弹窗  月份选择款-->

		<div class="toast_data" v-if="showData" @click="toastBoxData">
			<div class="calendar_box">
				<div class="calendar">
					<div class="ym">
						<div class="yearBox">
							<span v-model="selectYear" @click.stop="toggle('nian')">{{selectYear}}年 <img src="../../assets/img/selectpink.png"
								 alt=""></span>
							<ul class="year_list" v-show="yearShow">
								<li v-for="(item,yearIndex) in year_list" :key="yearIndex" @click.stop="yearFn(item.id,item.txt)" :class="yearidx == yearIndex + 1 ? 'active' : ''">{{item.txt}}年</li>
							</ul>
						</div>
					</div>
					<ul class="monthBox">
						<li v-for="(monthItm,idx) in month_list" @click="monthFn(monthItm.id,monthItm.txt)"><span :class="monthidx == monthItm.id ? 'activeData' : ''">{{monthItm.txt}}月</span></li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				selectTime: '',
				showPopup: false,
				year: '', // 当前年份
				month: '', // 当前月份
				today: 0, // 当前日期
				calList: [], // 日历数组
				// progressData: [], // 日历中的特殊表识
				showData: false,
				yearidx: 1,
				monthidx: 1,
				yearShow: false,
				monthShow: false,
				year_list: [{
						txt: '2020',
						id: 1
					},
					{
						txt: '2019',
						id: 2
					},
				],
				month_list: [{
						txt: '1',
						id: 1
					},
					{
						txt: '2',
						id: 2
					},
					{
						txt: '3',
						id: 3
					},
					{
						txt: '4',
						id: 4
					},
					{
						txt: '5',
						id: 5
					},
					{
						txt: '6',
						id: 6
					},
					{
						txt: '7',
						id: 7
					},
					{
						txt: '8',
						id: 8
					},
					{
						txt: '9',
						id: 9
					},
					{
						txt: '10',
						id: 10
					},
					{
						txt: '11',
						id: 11
					},
					{
						txt: '12',
						id: 12
					},
				],
				activeVlueData: '',
				userIncomelogList: [],
				selectYear: '',
				selectMonth: '',
				selectToday: '',
			}
		},
		created() {
			var date = new Date();
			this.selectYear = date.getFullYear();
			this.selectMonth = date.getMonth() + 1;
			this.selectToday = date.getDate();
			this.monthidx =  date.getMonth() + 1;
		},
		mounted() {
			// this.getCalendar();
			this.user_income_log();
		},
		methods: {
			back() {
				this.$router.push('/userinfo')
			},
			toastBoxData() {
				this.showData = !this.showData;
			},
			user_income_log() {
				var date = new Date();
				this.selectYear = this.selectYear || date.getFullYear();
				this.selectMonth = this.selectMonth || date.getMonth() + 1;
				this.$axios.post(this.$api.user_income_log, {
					time: this.selectYear + '-' + this.selectMonth
				}).then(res => {
					this.userIncomelogList = res.data.data;
				})
			},
			showDataFn() {
				this.showData = !this.showData;
			},
			toggle(a) {
				if (a == 'nian') {
					this.yearShow = !this.yearShow;
					this.monthShow = false;
				} else if (a == 'yue') {
					this.monthShow = !this.monthShow;
					this.yearShow = false;
				}
			},
			yearFn(id, txt) {
				console.log(txt)
				this.yearidx = id;
				this.selectYear = txt; //筛选年份
				// this.yearSele = txt;
				this.yearShow = !this.yearShow;
				// this.getCalendar(this.selectYear, this.selectMonth);
			},
			monthFn(id, txt) {
				console.log(txt)
				this.monthidx = id;
				this.selectMonth = txt; //筛选月份
				this.monthShow = !this.monthShow;
				this.user_income_log();
				// this.getCalendar(this.selectYear, this.selectMonth);
			},
			// getCalendar(cYear, cMonth) {
			// 	let calendarArr = [];
			// 	let myDate = new Date();
			// 	let year = cYear || this.selectYear ? this.selectYear : myDate.getFullYear();
			// 	let month = cMonth || this.selectMonth ? this.selectMonth : (myDate.getMonth() + 1);
			// 	let today = myDate.getDate();
			// 	this.year = year;
			// 	this.month = month;
			// 	this.today = today;
			// 	let buweinum = 1;
			// 	// 获取上一个月的最后一天start
			// 	var day = new Date(myDate.getFullYear(), myDate.getMonth(), 0).getDate(); //获取上一个月的最后一天
			// 	var enddate = new Date(new Date().getFullYear(), new Date().getMonth() - 1, day); //获取上一个月的日期
			// 	let firstday = new Date(year, (month - 1), 1).getDay();
			// 	let days = new Date(year, month, 0).getDate();

			// 	var prevLastday = '';
			// 	if (day == 30) {
			// 		prevLastday = day - firstday + 1;
			// 	} else if (day == 31) {
			// 		prevLastday = day - firstday + 2;
			// 	}
			// 	for (let i = 0; i < days; i++) {
			// 		calendarArr[i] = i + 1;
			// 	}

			// 	for (let j = 0; j < firstday; j++) {
			// 		calendarArr.unshift('');
			// 	}
			// 	// 获取日历的行数  
			// 	let len = calendarArr.length;
			// 	let line = Math.ceil(len / 7);

			// 	for (let k = 0; k < line * 7 - len; k++) {
			// 		calendarArr.push('');
			// 	}
			// 	this.calList = calendarArr;
			// 	this.progressData = [{
			// 		day: 7,
			// 		month: 11,
			// 		year: 2019,
			// 		status: 0
			// 	}];
			// },
			/**
			 * 点击日期查询
			 * @param index
			 */
			// dayCheck(day) {
			// 	console.log('day------', day);
			// 	this.activeVlueData = day;
			// 	this.selectToday = day;
			// 	this.user_income_log();
			// 	this.showData = !this.showData;
			// },
			// 计算日历中每日任务的状态
			// showProgrssStatus(value) {
			// 	for (let item in this.progressData) {
			// 		if (this.progressData[item].day === value && this.progressData[item].month === this.month && this.progressData[
			// 				item].year === this.year) {
			// 			if (this.progressData[item].done_time >= this.progressData[item].all_time) {
			// 				return 1;
			// 			} else {
			// 				return this.progressData[item].status;
			// 			}
			// 		}
			// 	}
			// },

		}
	}
</script>

<style lang="less" scoped>
	.qjylBox {
		background-color: #fff;
		height: 100vh;
		overflow-y: scroll;

		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;

			/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;

				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}

		}

		.qjylBoxNum {
			padding: 0 16px;
			padding-top: 30px;

			.qjylNum_data {
				background-color: #fff;
				position: relative;
				padding: 20px 30px;
				font-weight: 600;
				color: #000000;
				border-radius: 15px;
				font-size: 30px;
				/*px*/
				-webkit-box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.1);
				/*no*/
				-moz-box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.1);
				/*no*/
				box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.1);
				/*no*/
				margin-bottom: 20px;

				.shouyi {
					line-height: 60px;

					p {
						i {
							font-style: normal;
							color: #ff4081;
							padding-left: 20px;
						}
					}
				}

				.dataIcon {
					img {
						width: 160px;
						position: absolute;
						top: 50%;
						right: 20px;
						transform: translateY(-50%);
					}
				}
			}

			//我的琼浆玉露
			.qjylNum {
				background-color: #fff;
				margin-bottom: 20px;
				-webkit-box-shadow: 0 0 2px 0 rgba(0, 0, 0, .2);
				/*no*/
				-moz-box-shadow: 0 0 2px 0 rgba(0, 0, 0, .2);
				/*no*/
				box-shadow: 0 0 2px 0 rgba(0, 0, 0, .2);
				/*no*/
				/*no*/
				border-radius: 15px;
				line-height: 80px;
				padding: 20px 30px;
				display: flex;
				font-weight: 600;
				color: #000000;
				font-size: 30px;

				/*px*/
				span {
					flex: 1;
				}

				span:last-child {
					text-align: right;
					color: #ff4081;
				}
			}
		}

		// 日历
		.toast_data {
			position: fixed;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			background-color: rgba(0, 0, 0, .3);
			width: 100vw;
			height: 100vh;

			.calendar_box {
				// height: calc(100vh - 504px);
				height: auto;
				margin: 50% auto;
				padding-top: 60px;
				overflow-y: scroll;
				position: relative;

				.qdDataIconBox {
					.qdDataIconLeft {
						position: absolute;
						left: 20%;
						top: 20px;
						height: 60px;
						z-index: 100;
					}

					.qdDataIconRight {
						position: absolute;
						right: 20%;
						top: 20px;
						height: 60px;
						z-index: 100;
					}
				}

				.calendar {
					background: url(../../assets/img/myicon/databg.png) no-repeat;
					background-size: 100% 106%;
					position: relative;
					width: 85vw;
					margin: 0 auto;
					height: auto;
					border-radius: 15px;
					font-family: "PingFangSC-Regular";
					overflow: hidden;
					padding-bottom: 20px;
					z-index: 1000;
					// background-color: #fff;

					.ym {
						// padding: 40px 20px 30px;
						height: 60px;
						line-height: 60px;
						font-size: 32px;
						/*px*/
						text-align: center;
						// display: flex;
						align-items: center;
						// justify-content: space-between;
						position: relative;
						// background-color: #FF4081;
						border-top-left-radius: 15px;
						border-top-right-radius: 15px;
						padding: 20px 0;

						.prev img {
							width: 30px;
							background-size: 100% 100%;
							position: absolute;
							top: 50%;
							left: 34%;
							transform: translateY(-50%);
						}

						.currentData {
							flex: 1;
							font-family: PingFangSC-Medium;
							font-size: 28px;
							/*px*/
							color: #1b1b1b;
						}

						.next img {
							width: 30px;
							background-size: 100% 100%;
							position: absolute;
							top: 50%;
							right: 34%;
							transform: translateY(-50%);
						}

						.yearBox {
							// flex: 1;
							text-align: left;
							position: relative;

							span {
								padding: 0px 20px;
								border: 1px solid #fff;
								/*no*/
								border-radius: 10px;
								// margin-left: 10px;
								color: #fff;
								color: #ff4081;
								position: absolute;
								// right: 10px;
								left: 40px;
								top: 20px;
								transform: translateY(-50%);

								img {
									vertical-align: middle;
									width: 20px;
									/*px*/
								}
							}

							.year_list {
								position: absolute;
								left: 60px;
								top: 44px;
								border-radius: 5px;
								background-color: #fff;
								-webkit-box-shadow: 0 0px 6px 0 rgba(0, 0, 0, .3);
								/*no*/
								-moz-box-shadow: 0 0px 6px 0 rgba(0, 0, 0, .3);
								/*no*/
								box-shadow: 0 0px 6px 0 rgba(0, 0, 0, .3);
								/*no*/
								height: 300px;
								overflow-y: scroll;

								li {
									padding: 0 20px;
									border-bottom: 1px solid #f0f0f0;
									/*no*/
								}

								li.active {
									color: #fff;
									background-color: #FF4081;
								}
							}
						}
					}

					.monthBox {
						width: 74vw;
						margin: 0 auto;

						li {
							width: calc((122% / 3) - 80px);
							margin-right: 40px;
							display: inline-block;
							text-align: center;
							margin-bottom: 40px;
						}

						li span {
							width: 80px;
							/*px*/
							height: 80px;
							/*px*/
							display: inline-block;
							line-height: 70px;
							/*px*/
							text-align: center;
						}

						li:nth-child(3n) {
							margin-right: 0;
						}

						li span.activeData {
							background: url(../../assets/img/myicon/syDataActive.png) no-repeat center;
							background-size: 110% 110%;
							color: #fff;
						}
					}
				}


			}
		}
	}
</style>
